import $api from "../../http/game"
export default class PlinkoService {
    static enterGame(){
        return $api.get("/PlinkoApi/enter_game")

    }
    static create_bet(costBet){
        return $api.post("/PlinkoApi/create_bet",{costBet})
    }
    static increment_balance(result,koef,id){
        return $api.post("/PlinkoApi/increment_balance",{result,koef,id})
    }
    static game_other(){
        return $api.post("/PlinkoApi/game_other")

    }
}